<div #topbarWrap class="top-bar-wrap">
    <ng-container *ngIf="showTopbar">
    <app-waitlist-banner></app-waitlist-banner>
    <div class="bg-white w-full border-bottom-1 surface-border py-2 md:py-4">
    <div class="layout-content-side-padding w-full mx-auto flex flex-row justify-content-between align-items-center"
        [ngStyle]="{ 'max-width': 'none' }">
        <div class="flex">
            <a [routerLink]="['/dashboard']" class="inline-flex align-items-center">
                <img src="assets/images/DFC-logo.webp" alt="Dollar Flight Club Logo" class="app-logo-topbar">
            </a>
        </div>
        <div class="flex flex-row md:gap-2 gap-1 align-items-center">
            <div class="hidden lg:flex flex-row md:gap-2 gap-1 align-items-center">
                <a *ngFor="let link of navLinks" [routerLink]="link.authOnly && !user ? '/login' : link.route" routerLinkActive #navLinkActive="routerLinkActive" (click)="trackTabClick(link.label, NavSurface.DesktopNav)">
                    <p-button severity="secondary" [rounded]="true" [text]="true">
                        <span [ngClass]="navLinkActive.isActive ? 'font-bold text-900' : 'font-medium text-600'">{{ link.label }}</span>
                    </p-button></a>
            </div>
            <ng-container *ngIf="user; else loggedOutActions">
                <p-button *ngIf="user && !user.isPremiumPlus" class="hidden md:block px-3 go-premium-btn"
                    label="Go Premium+" [rounded]="true" (click)="goToUpgradeFromMenu()" />
                <ng-container *ngIf="{dollars: availableRewardsDollars$ | async} as availableRewards">
                    <a *ngIf="availableRewards.dollars !== null" routerLink="/rewards"
                        class="flex align-items-center gap-2 h-3rem px-3 border-round-3xl bg-blue-50 hover:bg-blue-100 text-blue-600 text-base font-semibold no-underline white-space-nowrap">
                        <i class="ph ph-wallet text-2xl" aria-hidden="true"></i>{{ availableRewards.dollars | currency: 'USD' : 'symbol' : '1.2-2' }}</a>
                </ng-container>
                <div #menuDiv class="pl-2">
                    <p-avatar icon="ph ph-user" styleClass="cursor-pointer hover:text-500" shape="circle" size="large"
                        (click)="openMenu($event)" />
                </div>
            </ng-container>
            <ng-template #loggedOutActions>
                <p-button severity="secondary" [rounded]="true" [text]="true" [routerLink]="'/login'">
                    <ng-template pTemplate="content"><span class="font-medium text-600">Login</span></ng-template>
                </p-button>

                <p-button class="px-2 md:px-4" label="Join for free →" [rounded]="true" severity="secondary"
                    styleClass="font-bold px-5" [raised]="true" [routerLink]="'/signup/14daytrialorganic'"></p-button>
            </ng-template>
        </div>
    </div>
</div>

<p-overlayPanel #op
    styleClass="user-menu-offset filter-panel p-overlaypanel-z-10009 p-overlaypanel-content-p-0 min-w-20rem"
    [hideTransitionOptions]="'0ms ease-out'">
    <ng-template [ngTemplateOutlet]="menuContent"></ng-template>
</p-overlayPanel>

<nav
    class="mobile-tabbar lg:hidden fixed left-0 bottom-0 w-full grid grid-nogutter border-top-1 surface-border"
    style="z-index: 1000; background: var(--surface-0); padding: 6px 4px max(10px, env(safe-area-inset-bottom))"
    aria-label="Main"
>
    <a
        *ngFor="let tab of mobileTabs"
        class="col flex flex-column align-items-center gap-1 py-1 no-underline text-600 text-xs font-semibold"
        [routerLink]="tab.authOnly && !user ? '/login' : tab.route"
        routerLinkActive="text-900"
        (click)="trackTabClick(tab.label, NavSurface.MobileTabBar)"
    >
        <i class="ph text-2xl" [ngClass]="tab.icon" aria-hidden="true"></i>
        <span>{{ tab.label }}</span>
    </a>
</nav>

<p-dialog [(visible)]="showMobileDialog" [modal]="true" closeable="false" baseZIndex="10009"
    styleClass="p-dialog-header-none p-dialog-content-p-0 p-dialog-content-border-radius-6px w-full px-3 border-round-xl"
    dismissableMask="true" [transitionOptions]="'0ms'">
    <ng-template [ngTemplateOutlet]="menuContent"></ng-template>
</p-dialog>

<ng-template #menuContent>
    <p-menu #menu [model]="items" styleClass="top-bar-menu w-full md:w-18rem border-1 border-200 border-round-xl pt-2 px-1"
        [baseZIndex]="10003">
        <ng-template pTemplate="start">
            <div class="flex flex-row p-3 justify-content-start align-items-center gap-3 cursor-pointer"
                *ngIf="!user?.isPremiumPlus" (click)="goToUpgradeFromMenu()">
                <div class="flex justify-content-center align-items-center bg-primary-100 border-round h-3rem w-3rem">
                    <i class="ph ph-hand-waving text-2xl wave-once"></i>
                </div>
                <div class="flex flex-column">
                    <span class="font-bold"> Upgrade plan</span>
                    <span class="text-sm">You deserve the best!</span>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="submenuheader" let-item>
        </ng-template>
        <ng-template pTemplate="item" let-item>
            <a pRipple class="top-bar-menu-item flex align-items-center p-menuitem-link">
                <span class="font-semibold">{{ item.label }}</span>
            </a>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="flex flex-row justify-content-center align-items-center gap-4 p-1">
                <span class="social-icon-wrap" *ngFor="let s of socialLinks" (click)="goExternal(s.url, s.label)">
                    <!-- outline -->
                    <i class="social-icon outline text-2xl" [ngClass]="['ph', s.icon]"></i>

                    <!-- filled -->
                    <i class="social-icon fill text-2xl" [ngClass]="['ph-fill', s.icon]"></i>
                </span>
            </div>
        </ng-template>

    </p-menu>
</ng-template>
</ng-container>
</div>

